import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faEnvelope, faLock, faSpinner } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { BASE_URL } from "../Apis/endpoints";

// Add this CSS block for autofill styling
const autofillStyles = `
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important; /* Forces white background */
    -webkit-text-fill-color: #475569 !important; /* Ensures text color remains readable */
    transition: background-color 5000s ease-in-out 0s; /* Prevents transition flicker */
  }
`;

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [message, setMessage] = useState({ text: "", type: "" });
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false); // New state to track submission
    const [formData, setFormData] = useState({
        email: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage({ text: "", type: "" });

        try {
            const response = await axios.post(`${BASE_URL}api/userauth/forgot-password/`, {
                email: formData.email,
            });

            if (response.status === 200) {
                setIsSubmitted(true); // Hide form and show success message
            } else {
                setMessage({
                    text: response.data.error || response.data.detail || response.data.message || "Failed to send reset link. Please try again.",
                    type: "error",
                });
            }
        } catch (error) {
            setMessage({
                text:
                    error.response?.data?.detail ||
                    error.response?.data?.message ||
                    error.response?.data?.error ||
                    "Failed to send reset link. Please try again.",
                type: "error",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            className="background-container w-full min-h-screen flex flex-col items-center bg-[#F8FAFC] px-4 sm:px-8 md:px-10 lg:px-16"
            style={{
                backgroundImage: "url('/images/background.svg')", // Changed to background.svg
                backgroundSize: "cover",
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center"
            }}
        >
            {/* Inject autofill styles */}
            <style dangerouslySetInnerHTML={{ __html: autofillStyles }} />

            <img
                src="/images/Transpoze_logo.svg"
                alt="Transpoze logo"
                // Logo sizing for various screens - kept consistent
                className="mt-2 sm:mt-4 md:mt-6 lg:mt-8 xl:mt-10 2xl:mt-12 3xl:mt-14 4xl:mt-16 5xl:mt-18 6xl:mt-20 7xl:mt-22
                           max-w-[150px] sm:max-w-[180px] md:max-w-[200px] lg:max-w-[220px] xl:max-w-[250px] 2xl:max-w-[280px]
                           3xl:max-w-[350px] 4xl:max-w-[420px] 5xl:max-w-[500px] 6xl:max-w-[600px] 7xl:max-w-[750px]"
            />

            {/* "Invisible cart" container for layout - FURTHER REDUCED TOP MARGIN */}
            <div className="p-6 sm:p-8 md:p-10 lg:p-12 xl:p-16 2xl:p-20 3xl:p-28 4xl:p-36 5xl:p-44 6xl:p-56 7xl:p-72
                            w-11/12 max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-3xl
                            3xl:max-w-4xl 4xl:max-w-5xl 5xl:max-w-6xl 6xl:max-w-[1200px] 7xl:max-w-[1600px]
                            mx-auto mt-0 sm:mt-0 md:mt-0 lg:mt-1 xl:mt-2 2xl:mt-3 3xl:mt-4 4xl:mt-5 5xl:mt-6 6xl:mt-8 7xl:mt-10 mb-auto flex flex-col items-center">
                {/* Show confirmation message if submitted, otherwise show form */}
                {isSubmitted ? (
                    <>
                        <h2
                            // Heading font sizes - REDUCED by one step further
                            className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl
                                       3xl:text-[40px] 4xl:text-[50px] 5xl:text-[60px] 6xl:text-[70px] 7xl:text-[80px]
                                       text-[#1E293B] font-bold font-sans text-center mt-2 sm:mt-4 mb-2 sm:mb-3 md:mb-4 lg:mb-5 xl:mb-6 2xl:mb-8 3xl:mb-10 4xl:mb-12 5xl:mb-14 6xl:mb-16 7xl:mb-20" // REDUCED MARGIN-BOTTOM
                            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                        >
                            Reset Password
                        </h2>
                        <p className="text-center text-[#64748B]
                                      text-xs sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl // FURTHER REDUCED
                                      3xl:text-2xl 4xl:text-3xl 5xl:text-4xl 6xl:text-[22px] 7xl:text-[28px] mb-6
                                      px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 3xl:px-20 4xl:px-24 5xl:px-28 6xl:px-32 7xl:px-40"> {/* ADDED HORIZONTAL PADDING */}
                            The Link has been successfully shared to your email.
                        </p>
                        <div
                            className="mt-4 sm:mt-6 md:mt-8 lg:mt-10 xl:mt-12 2xl:mt-16
                                       3xl:mt-24 4xl:mt-32 5xl:mt-40 6xl:mt-56 7xl:mt-72 text-center"
                        >
                            <a
                                href="/login"
                                className="text-[#2C67F2] font-semibold hover:underline flex items-center justify-center
                                           text-xs sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl // FURTHER REDUCED
                                           3xl:text-2xl 4xl:text-3xl 5xl:text-4xl 6xl:text-[20px] 7xl:text-[26px]" // FURTHER REDUCED
                            >
                                <FontAwesomeIcon icon={faChevronLeft} className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 md:w-4.5 md:h-4.5 lg:w-5.5 lg:h-5.5 xl:w-6.5 xl:h-6.5 2xl:w-7.5 2xl:h-7.5
                                                                                3xl:w-8.5 3xl:h-8.5 4xl:w-10.5 4xl:h-10.5 5xl:w-12.5 5xl:h-12.5 6xl:w-14.5 6xl:h-14.5 7xl:w-18.5 7xl:h-18.5 mr-1" /> {/* Proportional icon size reduction */}
                                Back to login screen
                            </a>
                        </div>
                    </>
                ) : (
                    <>
                        <h2
                            // Heading font sizes - REDUCED by one step further
                            className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl
                                       3xl:text-[40px] 4xl:text-[50px] 5xl:text-[60px] 6xl:text-[70px] 7xl:text-[80px]
                                       text-[#1E293B] font-bold font-sans text-center mt-2 sm:mt-4 mb-2 sm:mb-3 md:mb-4 lg:mb-5 xl:mb-6 2xl:mb-8 3xl:mb-10 4xl:mb-12 5xl:mb-14 6xl:mb-16 7xl:mb-20" // REDUCED MARGIN-BOTTOM
                            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                        >
                            Reset Your Password
                        </h2>
                        <p className="text-center text-[#64748B]
                                      text-xs sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl // FURTHER REDUCED
                                      3xl:text-2xl 4xl:text-3xl 5xl:text-4xl 6xl:text-[22px] 7xl:text-[28px] mb-6
                                      px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 3xl:px-20 4xl:px-24 5xl:px-28 6xl:px-32 7xl:px-40"> {/* ADDED HORIZONTAL PADDING */}
                            Forgot your password? No worries, then let’s submit password reset. It will be send to your email.
                        </p>
                        <form onSubmit={handleSubmit} className="font-semibold w-full space-y-4 sm:space-y-5 md:space-y-6">
                            <div className="mb-4">
                                <label className="block mb-2 text-[#1E293B] mt-2
                                                  text-xs sm:text-sm md:text-sm lg:text-md xl:text-lg 2xl:text-xl // FURTHER REDUCED
                                                  3xl:text-2xl 4xl:text-3xl 5xl:text-4xl 6xl:text-5xl 7xl:text-6xl" htmlFor="email"> {/* FURTHER REDUCED */}
                                    Email Address
                                </label>
                                <div className="relative flex items-center border border-[#E2E8F0] rounded-full bg-white">
                                    <FontAwesomeIcon icon={faEnvelope} className="ml-3 sm:ml-4 text-[#94A3B8]
                                                                                    text-sm sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl // FURTHER REDUCED
                                                                                    3xl:text-3xl 4xl:text-4xl 5xl:text-5xl 6xl:text-[22px] 7xl:text-[28px]" /> {/* Proportional icon size reduction */}
                                    <input
                                        className="p-3 sm:p-3.5 w-full rounded-full bg-white text-[#475569] focus:outline-none placeholder:text-[#94A3B8]
                                                   text-xs sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl // FURTHER REDUCED
                                                   3xl:text-2xl 4xl:text-3xl 5xl:text-4xl 6xl:text-[22px] 7xl:text-[28px]" // FURTHER REDUCED
                                        name="email"
                                        onChange={handleChange}
                                        type="email"
                                        id="email"
                                        value={formData.email}
                                        placeholder="example@gmail.com"
                                        required
                                    />
                                </div>
                            </div>
                            {message.text && (
                                <div className={`text-center mt-2 ${message.type === "success" ? "text-green-500" : "text-red-500"}
                                                  text-xs sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl // FURTHER REDUCED
                                                  3xl:text-2xl 4xl:text-3xl 5xl:text-4xl 6xl:text-[22px] 7xl:text-[28px]`}> {/* FURTHER REDUCED */}
                                    {message.text}
                                </div>
                            )}
                            <button
                                type="submit"
                                className="w-full flex items-center justify-center gap-2 bg-[#2C67F2] text-white
                                           p-2 sm:p-2.5 md:p-3 lg:p-2.5 xl:p-3 2xl:p-3.5 3xl:p-4 4xl:p-4.5 5xl:p-5 6xl:p-6 7xl:p-7 rounded-full hover:bg-blue-700 disabled:bg-blue-300 // REDUCED PADDING FOR LARGER SCREENS
                                           text-xs sm:text-xs md:text-xs lg:text-sm xl:text-base 2xl:text-lg // FURTHER REDUCED
                                           3xl:text-xl 4xl:text-2xl 5xl:text-3xl 6xl:text-[18px] 7xl:text-[24px] font-semibold transition-colors duration-200" // FURTHER REDUCED
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <FontAwesomeIcon icon={faSpinner} className="animate-spin
                                                                                    w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 md:w-4.5 md:h-4.5 lg:w-5.5 lg:h-5.5 xl:w-6.5 xl:h-6.5 2xl:w-7.5 2xl:h-7.5 // Proportional icon size reduction
                                                                                    3xl:w-8.5 3xl:h-8.5 4xl:w-10.5 4xl:h-10.5 5xl:w-12.5 5xl:h-12.5 6xl:w-14.5 6xl:h-14.5 7xl:w-18.5 7xl:h-18.5" />
                                        Sending...
                                    </>
                                ) : (
                                    <>
                                        Reset Password
                                        <FontAwesomeIcon icon={faLock} className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 md:w-4.5 md:h-4.5 lg:w-5.5 lg:h-5.5 xl:w-6.5 xl:h-6.5 2xl:w-7.5 2xl:h-7.5 // Proportional icon size reduction
                                                                                  3xl:w-8.5 3xl:h-8.5 4xl:w-10.5 4xl:h-10.5 5xl:w-12.5 5xl:h-12.5 6xl:w-14.5 6xl:h-14.5 7xl:w-18.5 7xl:h-18.5" />
                                    </>
                                )}
                            </button>
                        </form>
                        <div
                            className="mt-4 sm:mt-6 md:mt-8 lg:mt-10 xl:mt-12 2xl:mt-16
                                       3xl:mt-24 4xl:mt-32 5xl:mt-40 6xl:mt-56 7xl:mt-72 text-center"
                        >
                            <a href="/login" className="text-[#2C67F2] font-semibold hover:underline flex items-center justify-center
                                                       text-xs sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl // FURTHER REDUCED
                                                       3xl:text-2xl 4xl:text-3xl 5xl:text-4xl 6xl:text-[20px] 7xl:text-[26px]"> {/* FURTHER REDUCED */}
                                <FontAwesomeIcon icon={faChevronLeft} className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 md:w-4.5 md:h-4.5 lg:w-5.5 lg:h-5.5 xl:w-6.5 xl:h-6.5 2xl:w-7.5 2xl:h-7.5 3xl:w-8.5 3xl:h-8.5 4xl:w-10.5 4xl:h-10.5 5xl:w-12.5 5xl:h-12.5 6xl:w-14.5 6xl:h-14.5 7xl:w-18.5 7xl:h-18.5 mr-1" /> {/* Proportional icon size reduction */}
                                Back to login screen
                            </a>
                        </div>
                    </>
                )}
            </div>
            {/* Footer - consistent with Login */}
            <footer
                className="w-full text-[#94A3B8] font-normal
                           text-xs sm:text-xs md:text-xs lg:text-sm xl:text-base 2xl:text-lg // FURTHER REDUCED
                           3xl:text-xl 4xl:text-2xl 5xl:text-3xl 6xl:text-[16px] 7xl:text-[22px] flex justify-center items-center py-4 sm:py-6 mt-auto border-t border-[#E2E8F0]" // FURTHER REDUCED
            >
                Copyright {new Date().getFullYear()} Transpoze ©
            </footer>
        </div>
    );
};

export default ForgotPassword;